module.exports = __webpack_public_path__ + "img/small_income_logo.72e61aa5.svg";